var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('flex-element',{staticClass:"f-flex",attrs:{"element-type":_vm.elementType,"tag":"div"},on:{"click":_vm.emitClickEvent}},[_c('font-awesome-icon',{class:_vm.iconClasses,attrs:{"icon":[_vm.renderSet, _vm.renderIcon]}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }